import { formatDate } from '../../../../../utils/dateFormat';
export { formatDate };

// Memoized visa provider renderer
export const renderVisaProvider = (item) => {
  return item.visa_provider || item.Overseas_visa_provider || "-";
};

// Memoized status renderer
export const renderAbscondingStatus = (item) => {
  return item?.absconding_status === null 
    ? "ABSCONDING-RUN AWAY" 
    : item?.absconding_status;
};

// Memoized columns configuration
export const ABSCONDING_RUNWAY_COLUMNS = [
  { key: 'serial', title: 'S.NO.', searchable: false },
  { key: 'point_of_hire', title: 'POINT OF HIRE', searchable: true },
  { key: 'candidate_id', title: 'EMPLOYEE ID', searchable: true },
  { key: 'name', title: 'EMPLOYEE NAME', searchable: true },
  { key: 'nationality', title: 'NATIONALITY', searchable: true },
  { key: 'actual_profession', title: 'ACTUAL PROFESSION', searchable: true },
  { key: 'visa_profession', title: 'VISA PROFESSION', searchable: true },
  { key: 'total_salary', title: 'TOTAL SALARY', searchable: true },
  { key: 'client', title: 'CLIENT', searchable: true },
  { key: 'visa_provider', title: 'VISA PROVIDER', searchable: true },
  { key: 'iqama_number', title: 'IQAMA NUMBER', searchable: true },
  { key: 'iqama_expiry_date_g', title: 'IQAMA EXPIRY DATE', searchable: true },
  { 
    key: 'arrival_date', 
    title: 'ARRIVAL DATE', 
    searchable: true,
    render: formatDate
  },
  { 
    key: 'mobilization_date', 
    title: 'MOBILIZATION DATE', 
    searchable: true,
    render: formatDate
  },
  { 
    key: 'demobilization_date', 
    title: 'DEMOBILIZATION DATE', 
    searchable: true,
    render: formatDate
  },
  { key: 'demobilization_comments', title: 'DEMOBILIZATION COMMENTS', searchable: true },
  { key: 'aging', title: 'ABSCOND AGING', searchable: true },
  { key: 'absconding_status', title: 'STATUS', searchable: true },
  { key: 'action', title: 'ACTION', searchable: false }
];

// Constants for better maintainability
export const ABSCONDING_RUNWAY_CONFIG = {
  API_ENDPOINT: "/demobilization/idleCandidates/ABSCONDING-RUN AWAY",
  DOWNLOAD_ENDPOINT: "/demobilization/idleCandidates/download/ABSCONDING-RUN AWAY",
  DOWNLOAD_FILENAME: "Absconding_summary",
  SEARCH_PLACEHOLDER: "Search by Employee ID, Visa Reference, Border Number...",
  NO_DATA_MESSAGE: "No absconding/runway data available",
  DEBOUNCE_MS: 300,
  DEFAULT_PAGE_SIZE: 50,
  PAGE_SIZE_OPTIONS: [50, 100, 500, 1000]
};

// Memoized searchable fields derived from columns
export const ABSCONDING_RUNWAY_SEARCHABLE_FIELDS = ABSCONDING_RUNWAY_COLUMNS
  .filter(col => col.searchable)
  .map(col => col.key);

// Search key mapping for backward compatibility
export const SEARCH_KEY_MAPPING = [
  "employee_id",
  "visa_reference_number", 
  "border_number"
];